import React from 'react';
import NotFoundImage from '../../assets/404-NotFound.png';
import Page from '../page';

function NotFound() {
  return (
    <Page>
      <div className={'not_found_img'}>
        <img src={NotFoundImage} alt={'404 Page Not Found'} />
      </div>
    </Page>
  );
}

export default NotFound;
